// Initialize theme object
window.theme = window.theme || {};

import '../scripts/components/index.js';
import '../scripts/utils/helpers/lazy-media.js';
import '../scripts/utils/localization-manager.js';
import '../scripts/utils/vat-toggle.js';


// Dispatch event when theme bundle is loaded
document.dispatchEvent(new CustomEvent('theme:loaded'));
window.theme.loaded = true;
